var exports = {
  "s": "xdbfd91f1--b37956--fotorama",
};

module.exports = exports;
